import React from "react";

import styles from "./index.module.scss";
import { ISubOrderListItem } from "../../../types";
import { reportUserBehavior } from "../../../../../utils/common";
import { useHistory } from "react-router-dom";
import useGetCh from "../../../../../hooks/useGetCh";
import moment from "moment";
import { sendReport } from "../../../../../utils/reporter";
import arrowRight from "./assets/arrow-right.png";

interface PropsType {
  content: ISubOrderListItem;
  firstItem: boolean;
  lastItem: boolean;
}

export default function ProgressItem(props: PropsType) {
  const { content, firstItem, lastItem } = props;
  let history = useHistory();
  const ch = useGetCh();

  console.log(content, firstItem, lastItem);

  function navigateToDetail(content) {
    console.log("根据不同的跳转到对应的详情页");
    console.log(content.subOrderType, "子单类型");
    // 跟进子单类型跳转到不同子单详情
    // 子单类型编码：移动单=101；远程单=102；取车单=103；预约单=201；环检单=202；施工单=203；还车单=204；施工结算单=301；外销结算单=302
    let baseUrl = "/serviceOrders/orderDetail";
    let url = "";
    let pa = "";
    let mcode = "";

    if (content.subOrderType === 101 || content.subOrderType === 102) {
      //移动远程单:subOrderType=101,subOrderType=102时有效
      mcode = "sub_order_list__click_to_move_remote_detail";
      url =
        baseUrl +
        `/moveRemoteDetail?ssReserveOrderCode=${content.ssReserveOrderCode}`;
      pa = `detail_page=移动远程单\`ssReserveOrderCode=${content.ssReserveOrderCode}`;
    } else if (content.subOrderType === 201) {
      //预约单
      mcode = "sub_order_list__click_to_reserve_detail";

      // 有灰度标识，则进入新页面
      const routePath = "/reserveDetailV2";
      url =
        baseUrl + `${routePath}?reserveOrderCode=${content.reserveOrderCode}`;
      pa = `detail_page=预约单\`reserveOrderCode=${content.reserveOrderCode}`;
      sendReport({
        mcode: "服务记录查看预约详情点击",
        point: "P11184`B002",
        type: "page",
      });
    } else if (content.subOrderType === 202) {
      //
      mcode = "sub_order_list__click_to_envirl_inspection_sheet_detail";
      url =
        baseUrl +
        `/envirlInspectionSheetDetail?aroundCheckOrderNo=${content.aroundCheckOrderNo}`;
      pa = `detail_page=环检单\`aroundCheckOrderNo=${content.aroundCheckOrderNo}`;
    } else if (content.subOrderType === 203) {
      mcode = "sub_order_list__click_to_repair_order_detail";
      url =
        baseUrl +
        `/repairOrderDetail?repairOrderCode=${content.repairOrderCode}`;
      pa = `detail_page=施工单\`repairOrderCode=${content.repairOrderCode}`;
    }
    // else if (content.subOrderType === 204) {
    //   mcode = "sub_order_list__click_to_return_detail";
    //   url =
    //     baseUrl +
    //     `/returnDetail?drivingOrderRecordSubId=${content.drivingOrderRecordSubId}`;
    //   pa = `detail_page=还车单\`drivingOrderRecordSubId=${content.drivingOrderRecordSubId}`;
    // }
    else if (content.subOrderType === 103 || content.subOrderType === 204) {
      mcode = "sub_order_list__click_to_return_detail";
      url =
        baseUrl +
        `/getAndReturnCarDetail?drivingOrderRecordSubId=${content.drivingOrderRecordSubId}&subOderType=${content.subOrderType}`;
      pa = `detail_page=还车单\`drivingOrderRecordSubId=${content.drivingOrderRecordSubId}`;
    } else if (content.subOrderType === 301) {
      mcode = "sub_order_list__click_to_settlement_detail";
      url =
        baseUrl +
        `/settlementDetail?repairSettlementCode=${content.repairSettlementCode}&subOderType=301`;
      pa = `detail_page=施工结算单\`repairSettlementCode=${content.repairSettlementCode}`;
    } else if (content.subOrderType === 302) {
      mcode = "sub_order_list__click_to_settlement_detail";
      url =
        baseUrl +
        `/settlementDetail?salesSettlementCode=${content.salesSettlementCode}&subOderType=302`;
      pa = `detail_page=外销结算单\`salesSettlementCode=${content.salesSettlementCode}`;
    }

    reportUserBehavior({
      so: "J001002",
      mcode,
      ch,
      pa,
    });

    console.log("详情跳转信息", content.subOrderType, url);

    setTimeout(() => {
      history.push(url);
    }, 300);
  }
  function navigateToAction(content, action) {
    console.log("根据不同的action 跳转到对应的签名页面", action.url);
    reportUserBehavior({
      so: "J001002",
      mcode: "sub_order_list__click_to_action",
      ch,
      pa: `subOrderTypeText=${content?.subOrderTypeText}\`url=${action.url}\`desc=${action.desc}`,
    });

    setTimeout(() => {
      window.open(action.url, "_self");
      // window.location.href = action.url;
      // history.push(action.url);
    }, 300);
  }
  return (
    <div
      className={`${styles.progressWrapper} ${
        firstItem ? "" : styles.firstProgressWrapper
      }`}
    >
      <div className={`${styles.top} ${firstItem ? "" : styles.firstTop}`}>
        <div className={styles.text}>
          <h3>{content?.subOrderTypeText}</h3>
        </div>
      </div>

      <div
        className={`${styles.contentArea} ${
          lastItem ? styles.lastContentArea : ""
        }`}
      >
        {content?.subOrderStatusText && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>服务状态</div>
            <div
              className={styles.statusText}
              onClick={
                content?.displayDetail !== 0
                  ? () => {
                      navigateToDetail(content);
                    }
                  : undefined
              }
            >
              <div className={styles.subOrderStatusText}>
                {content?.subOrderStatusText}
              </div>
              {content?.displayDetail !== 0 && (
                <img
                  className={styles.detailArrow}
                  src={arrowRight}
                  alt=""
                ></img>
              )}
            </div>
          </div>
        )}

        {content?.serviceTimeTitle && content?.serviceTime && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>{content?.serviceTimeTitle}</div>
            <div className={styles.cellContent}>
              {moment(content?.serviceTime).format("YYYY/MM/DD HH:mm")}
            </div>
          </div>
        )}

        {content.repairOrderCode && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>结算金额</div>
            <div className={styles.cellContent}>
              {`￥ ${content?.settlementAmount}`}
            </div>
          </div>
        )}
        {content.subOrderType === 204 && content.verifyCode && (
          <div className={styles.cellWapper}>
            <div className={styles.cellTitle}>取车验证码</div>
            <div className={styles.cellContent}>{content?.verifyCode}</div>
          </div>
        )}

        {content?.actions && content?.actions?.length > 0 && (
          <div className={styles.actionWrapper}>
            {content?.actions?.map((item, index) => {
              return (
                <div className={styles.actionItem} key={index}>
                  <span className={styles.desc}>{item.desc}</span>
                  <div
                    className={styles.btn}
                    onClick={() => {
                      navigateToAction(content, item);
                    }}
                  >
                    {item.text}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
